import React, { useEffect, useState } from "react";
import api from "~/services/api";
import { Label, Input, Select } from "~/componentes/CustomForm";

import { Container } from "./styles";
import CustomScrollBar from "~/componentes/CustomScrollBar";
import { Materialize } from "~/styles/materializeGrid";
import { SLModalFooter } from "~/pages/Sistema/componentes/SistemaList";
import ShowConfirmacao from "~/utils/ShowConfirmacao";
import ProdutosList from "../ProdutosList";

function CreateEditContent({ mountedData }) {
  const [perfis, setPerfis] = useState([]);
  const [coordenadores, setCoordenadores] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [nome, setNome] = useState(mountedData ? mountedData?.nome : "");
  const [ativo, setAtivo] = useState(!mountedData ? "true" : mountedData?.ativo ? "true" : "false");

    useEffect(() => {
      api.get("/signed/empresa/gestorprojeto/gerencia/coordenadores", { params: { ativo: 1 } }).then((r) => setCoordenadores(r?.data));
    api.get("/signed/empresa/administracao/gerenciamento/perfis", { params: { ativo: 1 } })
      .then((r) => {
        let itensFilter = []
        for (let item of r?.data) {
          itensFilter.push({ nome: item?.usuario?.nome, ...item });
        }

        setPerfis(itensFilter)
      });
  }, []);

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let thisData = {
          ...data,
          ...(mountedData?.id ? { id: mountedData?.id } : {}),
          ativo: ativo === "true" ? true : false,
          produtos,
        }
        let response;
        if (mountedData?.id)
          response = await api.put("/signed/empresa/gestorprojeto/gerencia/analista", thisData);
        else
          response = await api.post("/signed/empresa/gestorprojeto/gerencia/analista", thisData);

        if (response?.status === 200) {
          closeReload && closeReload();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao ${mountedData?.id ? "atualizar" : "cadastrar"} essa Etapa, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja ${mountedData?.id ? "atualizar" : "cadastrar"} essa Etapa?`,
        successModal: `Etapa ${mountedData?.id ? "atualizada" : "cadastrada"} com sucesso!`,
      }
    );
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row header">
          <p className="h-descricao">Preencha as informações corretamente, e se atente ao (*) pois são campos obrigatórios</p>
        </div>
        <div className="row">
          <Label title="Perfil *" className="col s2 m2 l2">
            <Select
              isString
              list={{ list: perfis, value: "id", label: "nome" }}
              name="idPerfil"
              firstOption
              defaultValue={mountedData?.idPerfil}
              onChange={(e) => {
                const v = parseInt(e.currentTarget.value) || 0;
                const item = perfis?.find((e) => e?.id === v);

                if (item) {
                  setNome(item?.nome);
                }
              }}
            />
          </Label>
          <Label title="Nome *" className="col s5 m5 l5">
            <Input name="nome" disabled defaultValue={nome} />
          </Label>
          <Label title="Coordenadores *" className="col s3 m3 l3">
            <Select
              isString
              list={{ list: coordenadores, value: "id", label: "nome" }}
              name="idCoordenador"
              firstOption
              defaultValue={mountedData?.idCoordenador}
            />
          </Label>
          <Label title="Ativo *" className="col s2 m2 l2">
            <Select
              isString
              list={{ list: [{ id: "true", titulo: "Sim" }, { id: "false", titulo: "Não" }], value: "id", label: "titulo" }}
              name="ativo"
              defaultValue={mountedData?.ativo?.toString()}
              onChange={(e) => {
                const v = e.currentTarget.value || "true";
                setAtivo(v);
              }}
            />
          </Label>
        </div>
        <div className="row">
          <div className="col s12 m12 l12">
            <ProdutosList setter={setProdutos} defaultData={mountedData?.produtos || []} />
          </div>
        </div>
      </Materialize>
    </Container>
  );
}

export default CreateEditContent;
